<div class="terminal-sim-device" role="dialog" aria-label="Simulated Square Terminal">
  <div class="terminal-sim-brand">SQUARE TERMINAL</div>
  <div class="terminal-sim-sandbox">SANDBOX</div>
  <div class="terminal-sim-prompt">Present card</div>
  <div class="terminal-sim-amount">${{ formatMoney(amount) }}</div>
  <p class="terminal-sim-copy">
    This stands in for the shop Terminal. Approve as if the customer tapped or inserted a card.
  </p>
  <button mat-raised-button color="primary" type="button" (click)="approve()">
    APPROVE PAYMENT
  </button>
  <button mat-stroked-button type="button" (click)="decline()">DECLINE</button>
  <button mat-button type="button" (click)="cancel()">CANCEL</button>
</div>
